import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FaRegUser } from "react-icons/fa6";
import { motion } from "framer-motion";
import Slider from "react-slick";
import { useEffect, useState } from "react";
import axios from "axios";
import NotFound from "../shared/NotFound";

interface Offer {
    id: string;
    title: string;
    img_offer: string;
    category: string;
    offer_start_date: string;
    offer_end_date: string;
    description: string;
    created_at: string;
    slug_title: string;
    author: {
        name: string;
    };
}

interface OfferCardProps {
    offer: Offer;
}

export default function LatestOffers() {
    const [data, setData] = useState<Offer[]>([]);

    const getData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/offer?limit=4`);
            if (response && response.data && response.data.data) {
                setData(response.data.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
            <div className="flex flex-col sm:flex-row justify-between text-sm mt-5">
                <div className="flex space-x-5 mb-4 sm:mb-0 whitespace-nowrap">
                    <h1 className="text-2xl font-poppinsBold text-bprDarkBlue">PENAWARAN TERKINI</h1>
                </div>
                <div className="flex items-center justify-start w-full sm:items-center sm:justify-end">
                    <Link to="/penawaran-terkini" className="font-poppinsBold text-bprDarkBlue text-lg">Selengkapnya</Link>
                </div>
            </div>
            <motion.div
                initial={{ opacity: 0, y: -100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2 }}
                className="mt-14"
            >
                <div className="block md:hidden">
                    <Slider {...settings}>
                        {data.length === 0 ? (
                            <NotFound></NotFound>
                        ) : (
                            data.map((offer) => (
                                <div key={offer.id} className="px-2">
                                    <OfferCard offer={offer} />
                                </div>
                            ))
                        )}
                    </Slider>

                </div>
                {data.length === 0 ? (
                    <div className="hidden md:block">
                        <NotFound />
                    </div>
                ) : (
                    <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-3">
                        {data.map((offer) => (
                            <OfferCard key={offer.id} offer={offer} />
                        ))}
                    </div>
                )}
            </motion.div>
        </div>
    );
}

function OfferCard({ offer }: OfferCardProps) {
    return (
        <Link to={`/detail-penawaran-terkini/${offer.slug_title}`} className="hover:shadow-xl">
            <div className="w-full h-[500px] rounded-xl overflow-hidden shadow-lg flex flex-col">
                <div className="w-full h-[300px]">
                    <LazyLoadImage
                        src={process.env.REACT_APP_API_ENDPOINT + "/offer/getimg/" + offer.img_offer}
                        alt="offers"
                        effect="blur"
                        className="w-full h-full object-cover object-top"
                        wrapperProps={{
                            style: { transitionDelay: '1s' },
                        }}
                    />
                </div>
                <div className="flex-grow flex flex-col justify-between p-3">
                    <div>
                        <div className="flex flex-row justify-between items-center text-[#B9B9B9] mb-2">
                            <div className="flex items-center space-x-2">
                                <FaRegUser /> <span className="text-sm pt-1" dangerouslySetInnerHTML={{ __html: offer.author.name }}></span>
                            </div>
                            <div className="flex justify-end">
                                <span className="text-sm pt-1 ml-auto">{new Date(offer.created_at).toLocaleDateString()}</span>
                            </div>
                        </div>
                        <div className="text-sm text-[#B9B9B9]">{offer.category}</div>
                        <div className="font-poppinsBold text-sm mt-2 mb-4 line-clamp-2" dangerouslySetInnerHTML={{ __html: offer.title }} />
                    </div>
                    <div className="pt-2">
                        <span className="font-poppinsRegular text-bprDarkBlue text-[12px]">
                            {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(offer.offer_start_date))} - {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(offer.offer_end_date))}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
}
